import serverInterface from 'server-interface';

import externalEventCodes from 'event-system/codes/external';

import {
  findIndexByPropertyValue
} from 'utilities/collection';
import {
  applyTraits
} from 'utilities/javascript';

import DataManagerTraits from '../traits';

class ConversationFiltersManager {

  constructor(application) {

    this.initialized = false;
    this.collection = [];

    this.application = application;

  }

  handleCreatedEvent(payload) {

    this.tryAdd(payload.conversationFilter);

  }

  handleUpdatedEvent(payload) {

    const item = payload.conversationFilter;

    this.tryRemove(item._id);
    this.tryAdd(item);

  }

  handleDeletedEvent(payload) {

    this.tryRemove(payload.conversationFilter._id);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.CONVERSATION_FILTER_CREATED, this.handleCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.CONVERSATION_FILTER_UPDATED, this.handleUpdatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.CONVERSATION_FILTER_DELETED, this.handleDeletedEvent.bind(this));

  }

  async loadAll() {

    this.collection = await serverInterface.startup.helpdesk.getConversationFilters();

  }

  async create(payload) {

    let item = await serverInterface.startup.helpdesk.createUserLevelConversationFilter(payload);

    this.tryAdd(item);

    return item;

  }

  async update(itemId, payload) {

    const updated = await serverInterface.startup.helpdesk.updateConversationFilterByConversationFilterId(itemId, payload);

    if (updated === true) {
      const item = this.getById(itemId);
      this.tryRemove(itemId);
      this.tryAdd({ ...item, ...payload });
    }

  }

  async delete(itemId) {

    await serverInterface.startup.helpdesk.deleteConversationFilterByConversationFilterId(itemId);

    this.tryRemove(itemId);

  }

  getInboxMessagesFilter() {

    const inboxFilterIndex = findIndexByPropertyValue(this.collection, 'name', 'Inbox');

    return this.collection[inboxFilterIndex];

  }

  getSentMessagesFilter() {

    const sentFilterIndex = findIndexByPropertyValue(this.collection, 'name', 'Sent');

    return this.collection[sentFilterIndex];

  }

  getDraftMessagesFilter() {

    const draftFilterIndex = findIndexByPropertyValue(this.collection, 'name', 'Drafts');

    return this.collection[draftFilterIndex];

  }

  getSpamMessagesFilter() {

    const spamFilterIndex = findIndexByPropertyValue(this.collection, 'name', 'Spam');

    return this.collection[spamFilterIndex];

  }

  getQuarantineMessagesFilter() {

    const quarantineFilterIndex = findIndexByPropertyValue(this.collection, 'name', 'Quarantine');

    return this.collection[quarantineFilterIndex];

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.collection = bootstrapData.conversationFilters;

    this.initialized = true;

  }

}

export default applyTraits(ConversationFiltersManager, [DataManagerTraits]);